import { render, staticRenderFns } from "./AppLogs.vue?vue&type=template&id=c2050bf6&scoped=true"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"
import style0 from "./AppLogs.vue?vue&type=style&index=0&id=c2050bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2050bf6",
  null
  
)

export default component.exports